<template>
  <div class="layout">
    <nav-bar />
    <slot />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-property-decorator'
import NavBar from './components/nav-bar/nav-bar.vue'

@Options({
  name: 'WithNavLayout',
  components: {
    NavBar,
  },
})
export default class WithNavLayout extends Vue {}
</script>

<style scoped lang="sass">
.layout
  display: flex
  flex-direction: column
  ::v-deep
    ion-router-outlet, .page
      position: relative
      // height: calc(100vh - 45px)
</style>
